// extracted by mini-css-extract-plugin
export default {"drawer-popup-right":"SystemSettings_drawer-popup-right__9AkVC"};